import { render, staticRenderFns } from "./DetailIndex.vue?vue&type=template&id=c94f93ec&scoped=true"
import script from "./DetailIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetailIndex.vue?vue&type=style&index=0&id=c94f93ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94f93ec",
  null
  
)

export default component.exports